var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _path, _path2, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _path3, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNatureBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "tree"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -54,
    width: 44,
    height: 44,
    fill: "#173523"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -54,
    width: 22,
    height: 22,
    fill: "#1f4530"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -14,
    width: 8,
    height: 14,
    fill: "#0c1f14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tuft",
    fill: "#0a1811"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -16,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11,
    y: -10,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: -10,
    width: 4,
    height: 10
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 110,
    fill: "#0d1b3a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110,
    width: 1600,
    height: 110,
    fill: "#142a52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220,
    width: 1600,
    height: 110,
    fill: "#1c3a68"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330,
    width: 1600,
    height: 110,
    fill: "#27517c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 440,
    width: 1600,
    height: 110,
    fill: "#35708c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 550,
    width: 1600,
    height: 110,
    fill: "#3f7f8f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#cfe0ee",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 96,
    width: 56,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 110,
    width: 98,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 124,
    width: 126,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 138,
    width: 98,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 78,
    width: 48,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 90,
    width: 84,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 102,
    width: 108,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 114,
    width: 84,
    height: 12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffcb05"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1273,
    y: 89,
    width: 54,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1255,
    y: 107,
    width: 90,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1237,
    y: 125,
    width: 126,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1219,
    y: 143,
    width: 162,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1219,
    y: 161,
    width: 162,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1219,
    y: 179,
    width: 162,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1237,
    y: 197,
    width: 126,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1255,
    y: 215,
    width: 90,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1273,
    y: 233,
    width: 54,
    height: 18
  }))), /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAALVBMVEUAAAAQEBBBKRhzSjGDg4OkYlq9KSC9vb3Ng1rmvWLuYkH/rHP/7pz/9r3///9WNuoZAAAAAXRSTlMAQObYZgAAAa5JREFUWMPt1LFKA0EQBuCLh9buaUAbSTZc1CBBPIQE4isIWRmIRZqgB2onvoAegQ3YeEHIQBqbFIe1jZWCkIPtbLSwEKx9BvcI1jdrYbV/vR+zs8Os49jY2NjY/CXutiFoGIJABiZi3pWRNAHdhpRGJTSIgo+YfqNXGe19vHED0O++I2KJChaODxHLjF7h7OGYeR6Qm154TO7qa55PB0kyEXWPt8mA1yYpcjpwqr2aUjGHRSqohSca+NCmirnkXqUcQF5RJ8G3FPrQkVIQhYt4qwtI2RcGoJMBKFEBwoYGAkpuQNhWDcYvflbA5w3ZiHKFm47VM8h+H0QMQUde5oGWUhqALiDiA909FQCIzaddaLPcAbauf8E4LbZXIicfTFXqg9BAsSLkfyDN1nSsR61bUKoIkH8lt4mDYZy1oK6XGCNMbiUYNtEXehzTG9KoC3rUGJcRByMacFYzgQxHeEkDhZkorw6oSzQTcZmRF7tQQRyS/75sT3ussmNwnFd7+vegg/X9sFcNQ/KV5i6+vPppcnROrsBY4es7ZMygaWf50+i4ftdFx8bGxsbm3/IDKBea6AbhhdgAAAAASUVORK5CYII=",
    x: 500,
    y: 150,
    width: 64,
    height: 64,
    style: {
      imageRendering: "pixelated"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,620 H150 V580 H320 V610 H480 V560 H700 V600 H900 V570 H1100 V610 H1300 V580 H1600 V900 H0 Z",
    fill: "#2b5140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,720 H130 V680 H300 V710 H460 V670 H620 V705 H780 V675 H960 V715 H1140 V680 H1320 V710 H1600 V900 H0 Z",
    fill: "#1f3f30"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(90,680) scale(0.9)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(215,700) scale(0.7)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(380,690) scale(1.0)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(540,670) scale(0.8)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(700,690) scale(0.9)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(860,675) scale(0.75)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(1040,700) scale(1.0)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(1220,680) scale(0.8)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(1400,700) scale(0.85)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    href: "#tree",
    transform: "translate(1550,700) scale(0.7)"
  })), /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAKlBMVEUAAAAAAAApKSlBQUpiMQhzc4OcUgDFIBjelADmWkH2vSD25lL/9qT////Vai+KAAAAAXRSTlMAQObYZgAAAdlJREFUWMPtlsFqwkAQhjclhB6ztRRReqiHXnoSbz0piLX2JcwliD6A0JsgEuoDlNJTQKzsnkJpSDN9A3PpG3U2ST12J4dCKftjNML/MTObndkwZmRkZPTX5Vb0Wxe/DrQq5nRSHehWBK4PQKtFAWpiU9wctTodygI0SsCZQqfTJgK+P3ZmgAClfltsJ9k+Qf8bKQACQZZlgHptqwC+lhh+ZNleAVz5HRjrAEwGUi4Tr/wX61JaSMzm8wrygo9BD5wjENVKYI3hNDnZbRiqlHJfAHrAuVQmeH9eqooJwB3AABN5egyL+rVF3MrldDtJ5/OwDKADbkSuHJAVgJf7kE1FTmg2lCNKheoOCa7froU2OSo5owLSHeG33s+aJQCuTfKzJhQBsNjRlpEAJHZSrY4tKBNkHeNSqk3XZXUKYEFSApH18D1BfgYAmwZ7CKJhsOsRgHUB7CAMgj5lGM9AIfgJ6wtGA2Ko45UK7lPmUjPGmRThlQr3zCMAM/BxhXz1MLhPAKyiBwCkEH2PkJIlCn+apiKklGDlPQBCYoSQdKBMxUG0o6hx8O9oh53VEAHnqndIj42x/kotpjWYrGgB7Djp5c6R8GgR+Gn5G0cVXwl41bcUIyMjo/+qLw92FGczGN4XAAAAAElFTkSuQmCC",
    x: 156,
    y: 727,
    width: 88,
    height: 88,
    style: {
      imageRendering: "pixelated"
    }
  }), /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAMFBMVEUAAAAQEBAYSkoxc3M5lJRSYili1bRzrDGD7sWk1UGsADG9/3PNzc3uIDn/amL///87EAzGAAAAAXRSTlMAQObYZgAAAZ1JREFUWMPtlL9Lw0AUx9NUce1JwMGlLUfbrdAGcVAkl0fI5iSloxiOrg4hiJuWcP+AlPwLASm4lWzB0dG9/0HAunbwpbjfq6PcZ/5+8n5weZZlMBgMhv/F4b75KaOHj5L4ZppMWuT8Y1Gssge6gPmiSLKYINjtukBRvJ0kK5IQPrXHyGhwWxTZyz1BUGOlUjlQOyHRlwhDpSCUKq2FBWFqX6k5hKmU0Wkt6Hs6xwKgdsIqW8Q0IVQpoJBlSawdojmYKRz6+aMHXrYgCPZnqubh7HJZgtdPiALUwmYnTLTCxTpUoObrfAtCUISrZYAzRMtqCz7040S7pbM8kLjSvHoHANHXCx35C/Da0D8NfiyDO8yPGLjQhY7+dV/nUt512DdgiS4X+tfK/bzGBYEdcWhrhYbjv1aVC54D2BRBQAOnBeaAK7CKR/hHPYagwz0cgiAcyAg3KiQIhyZYrsQoD6I9BPAYh1oQQDlMgYw8K0Ch4bouRWhGtSCjll2WJeXqDYe8ZfUC7IYx0qlsMGbZm83Xfqee+HGDwWAwGP7KD5Vqm0oTWykbAAAAAElFTkSuQmCC",
    x: 1310,
    y: 735,
    width: 80,
    height: 80,
    style: {
      imageRendering: "pixelated"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,850 H140 V810 H300 V840 H480 V800 H680 V830 H880 V805 H1080 V835 H1280 V810 H1600 V900 H0 Z",
    fill: "#13271d"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(60,888)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(180,882)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(300,890)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(420,878)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(780,886)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(900,880)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(1020,890)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(1140,882)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(1260,888)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(1380,880)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    href: "#tuft",
    transform: "translate(1500,888)"
  })), /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAMFBMVEUAAAAQEBBKKUFaWlpiSgiLSoukGDmkcwi0c73NrGLNzc3VnNXmWnPmzXPu3rT///9wkIOdAAAAAXRSTlMAQObYZgAAAbNJREFUWMPtlDFLw0AYhi+hoeKUgFILUmohUuyvEDLYpWjpYUD7DxxUKNGl2MDhJ51akCpIwc1NLAiB+wHdhY4dCopkuaXgWi/pD7g70KXcO9wReB/u3sv3fQhpaWlp/ZUA1PxrlGIloEsxHKoB1A9VAItGhBRVCBdCUALMkqsGcPmd/wasFQDKyoAttOBlvcGNJGBRsiztd0nArKQl3R2lm3kkfpZLqJdKZXpclgU+wgql0ShoJa3gijOjJvfTLpm2QgsfygIRkOmk4wMR3yhAJnA/QHPS4au4Q2vnJvcRF4ifAOL+yXz53Lb7wpctKQAl/vBnATtO4oe6EDjhAU7PFnAbBFccEKf2CQwZi4M2Y58g80zWHVvK8w6kgAxj+3l+gpdGwGIAed7cGbI4sfsEY/GvXl/MnRqLSTcq97EMgF7nTpXFm5TmH0tY5k57z9tjNuMVlfeQi3vigYobT2NmV+ibh5AxEAMubgzaM8QB/pGvXgiBHK5XmW1SmgyYjZwwtHF9XzQcZNIosRqG8ACj10+27APYkqPLTo3tWG3kZb+ZrQQYhYIaIJNWS0tLS2uV9QujEKugSNyd7gAAAABJRU5ErkJggg==",
    x: 572,
    y: 749,
    width: 56,
    height: 56,
    style: {
      imageRendering: "pixelated"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatureBg);
export default __webpack_public_path__ + "static/media/nature-bg.aad6afcee072ab7811d73854f9cd668e.svg";
export { ForwardRef as ReactComponent };